import "./form-transaction.scss";

import { TransactionFormSchema } from "@factory/form/form.rule";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";
import TextBlock from "@shared/ui/text-block/text-block";
import { currencyFormat } from "@shared/utility/formats/currency-format";
import { numberFormat } from "@shared/utility/formats/number-format";
import { Divider } from "primereact/divider";
import { useFormContext } from "react-hook-form";

import { appFeature } from "../../../app.feature";

type InputFormSchema = TransactionFormSchema;
export function FormTransaction() {
  const { pointsText, stampsText } = appFeature.config.label;
  const excludedColumns = appFeature.features.transaction["list-page"]
    .excludedColumns as string[];
  const { control, watch } = useFormContext<TransactionFormSchema>();
  const branchName = watch("branchName");
  const customerName = watch("customerName");
  const campaignName = watch("campaignName");
  const cardAlias = watch("cardAlias");
  const rewardEventName = watch("rewardEventName");
  const action = watch("action");
  const amount = watch("amount");
  const points = watch("points");
  const stamp = watch("stamp");
  const receiptNumber = watch("receiptNumber");

  return (
    <div id="FormTransaction" className="transaction">
      {branchName ? <TextBlock label="Branch" value={branchName} /> : null}
      {receiptNumber ? <TextBlock label="Receipt" value={receiptNumber} /> : null}
      {customerName ? (
        <TextBlock label="Customer" value={customerName} />
      ) : null}
      {campaignName ? (
        <TextBlock label="Campaign" value={campaignName} />
      ) : null}
      {cardAlias ? <TextBlock label="Card Number" value={cardAlias} /> : null}
      {rewardEventName ? (
        <TextBlock label="Reward Event" value={rewardEventName} />
      ) : null}
      {action ? <TextBlock label="Action" value={action} /> : null}
      {!excludedColumns.includes("amount") && amount ? (
        <TextBlock label="Amount" value={currencyFormat(amount, "PHP")} />
      ) : null}
      {points ? (
        <TextBlock label={pointsText} value={numberFormat(points)} />
      ) : null}
      {stamp ? (
        <TextBlock label={stampsText} value={numberFormat(stamp)} />
      ) : null}

      <Divider className="mt-4 mb-8" />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="remarks"
        label="Remarks"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter remarks"
      />
    </div>
  );
}

export default FormTransaction;
